import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const NakliyeReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.companyName || 'Transport Company'}</Text>
            <Text style={sharedStyles.businessDetails}>Vehicle: {data.vehicleNumber}</Text>
            <Text style={sharedStyles.businessDetails}>Driver: {data.driverName}</Text>
            <Text style={sharedStyles.businessDetails}>Route: {data.route}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Transport Trip Report</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Trip Date: {data.tripDate}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Income</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>Description</Text>
              <Text style={sharedStyles.tableCellRight}>Amount</Text>
            </View>
            {data.income && data.income.map((item, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>{item.description}</Text>
                <Text style={sharedStyles.tableCellRight}>${item.amount.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Expenses</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>Expense Item</Text>
              <Text style={sharedStyles.tableCellRight}>Amount</Text>
            </View>
            {data.expenses && data.expenses.map((expense, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>{expense.expenseItem}</Text>
                <Text style={sharedStyles.tableCellRight}>${expense.amount.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={{ ...sharedStyles.summaryLabel, color: '#4CAF50' }}>Total Income:</Text>
              <Text style={{ ...sharedStyles.summaryValue, color: '#4CAF50' }}>${data.totalIncome?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={{ ...sharedStyles.summaryLabel, color: '#f44336' }}>Total Expense:</Text>
              <Text style={{ ...sharedStyles.summaryValue, color: '#f44336' }}>${data.totalExpense?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Trip Profit:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.tripProfit?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Trip Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
          <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default NakliyeReportPDF;
